<template lang="pug">
main.container
    | Error.
</template>